module.exports = new Promise(function(resolve) {
  var resolved = false;
  var check;

  function settle(v) { if (resolved) return; resolved = true; clearInterval(check); resolve(v); }
  function isValid(c) { return c && typeof c.get === 'function' && typeof c.init === 'function'; }

  function proxy() {
    return {
      get: function(r) { return window["abax_ui"].get(r); },
      init: function() {
        try { return window["abax_ui"].init.apply(window["abax_ui"], arguments); }
        catch(e) { /* double-init safe */ }
      }
    };
  }

  function stub() {
    window.__ABAX_UI_LOAD_FAILED__ = true;
    return { get: function() { return Promise.resolve(function() { return {}; }); }, init: function() {} };
  }

  // The preload flips this the moment the remote entry load rejects, and never
  // retries afterwards, so it reports a DECIDED failure rather than a slow one.
  // Reading it is what keeps a known failure from costing the full timeout: the
  // entry chunk imports the remote statically, so nothing paints until this
  // promise settles.
  function decided() { return window.__ABAX_UI_LOAD_FAILED__ === true; }

  function giveUp(reason) {
    var msg = '[MF] Container "abax_ui" ' + reason + ' — booting without it.';
    // The same bundle ships to production, where a dev-server hint would name a
    // port that does not exist. Only offer it where it can be acted on.
    if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
      msg += ' Local dev: "pnpm run serve" (or "pnpm run serve:staging") starts the shell'
           + ' AND the @abax/ui remote on :4001; "pnpm run serve:shell" alone leaves it unserved.';
    }
    console.error(msg);
    settle(stub());
  }

  if (isValid(window["abax_ui"])) { resolve(proxy()); return; }
  if (decided()) { giveUp('failed to load'); return; }

  var elapsed = 0;
  check = setInterval(function() {
    elapsed += 50;
    if (isValid(window["abax_ui"])) { settle(proxy()); return; }
    if (decided()) { giveUp('failed to load'); return; }
    if (elapsed >= 10000) { giveUp('did not register within 10000ms'); }
  }, 50);
});